import { api } from "../../../services/api";
import { toast } from "react-toastify";

export async function fetchInitialRegister(email, senha, senhaConfirm) {
  return new Promise((resolve, reject) => {
    api
      .post(
        "/initial-register",
        {
          email,
          password: senha,
          confirmpassword: senhaConfirm
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then((response) => {
        toast.success(response.data);
        resolve(response.data);
      })
      .catch((error) => {
        toast.error(error.response.data);
        reject(error.response.data);
      });
  });
}
